(function () {
  'use strict';

  if (window.UfcCtaAbTest) {
    window.UfcCtaAbTest.init();
    return;
  }

  var COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90;
  var SELECTOR = '[data-ufc-cta-experiment]';

  function isVariant(value) {
    return value === 'A' || value === 'B';
  }

  function cookieValue(name) {
    var prefix = encodeURIComponent(name) + '=';
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0; i < cookies.length; i += 1) {
      if (cookies[i].indexOf(prefix) === 0) {
        return decodeURIComponent(cookies[i].slice(prefix.length));
      }
    }

    return null;
  }

  function saveAssignment(key, variant) {
    try {
      window.localStorage.setItem(key, variant);
    } catch (error) {
      // Storage may be unavailable in private browsing or a restricted iframe.
    }

    var cookie = encodeURIComponent(key) + '=' + encodeURIComponent(variant)
      + '; Path=/; Max-Age=' + COOKIE_MAX_AGE_SECONDS + '; SameSite=Lax';
    if (window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  function randomVariant() {
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] < 2147483648 ? 'A' : 'B';
    }

    return Math.random() < 0.5 ? 'A' : 'B';
  }

  function assignmentFor(experimentId) {
    var queryVariant = null;
    try {
      queryVariant = new URLSearchParams(window.location.search).get('ufc_cta_variant');
      if (queryVariant) queryVariant = queryVariant.toUpperCase();
    } catch (error) {
      queryVariant = null;
    }

    if (isVariant(queryVariant)) {
      return { variant: queryVariant, source: 'qa_override' };
    }

    var key = 'ufc_ab_' + experimentId;
    var storedVariant = null;
    try {
      storedVariant = window.localStorage.getItem(key);
    } catch (error) {
      storedVariant = null;
    }

    if (isVariant(storedVariant)) {
      return { variant: storedVariant, source: 'returning_visitor' };
    }

    var cookieVariant = cookieValue(key);
    if (isVariant(cookieVariant)) {
      saveAssignment(key, cookieVariant);
      return { variant: cookieVariant, source: 'returning_cookie' };
    }

    var variant = randomVariant();
    saveAssignment(key, variant);
    return { variant: variant, source: 'random_50_50' };
  }

  function deviceType() {
    if (window.matchMedia('(max-width: 749px)').matches) return 'mobile';
    if (window.matchMedia('(max-width: 1023px)').matches) return 'tablet';
    return 'desktop';
  }

  function publish(eventName, context) {
    var payload = {
      event: eventName,
      experiment_id: context.experimentId,
      experiment_variant: context.variant,
      experiment_variant_label: context.label,
      experiment_assignment_source: context.assignmentSource,
      cta_placement: context.placement,
      cta_destination: context.destination,
      page_path: window.location.pathname,
      device_type: deviceType()
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (context.ga4MeasurementId) {
      var ga4Parameters = {
        send_to: context.ga4MeasurementId,
        experiment_id: context.experimentId,
        experiment_variant: context.variant,
        experiment_variant_label: context.label,
        experiment_assignment_source: context.assignmentSource,
        cta_placement: context.placement,
        cta_destination: context.destination,
        page_path: window.location.pathname,
        device_type: deviceType()
      };
      if (context.assignmentSource === 'qa_override') ga4Parameters.debug_mode = true;

      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('event', eventName, ga4Parameters);
    }

    try {
      if (
        window.Shopify
        && window.Shopify.analytics
        && typeof window.Shopify.analytics.publish === 'function'
      ) {
        var publishResult = window.Shopify.analytics.publish('ufc:' + eventName, payload);
        if (publishResult && typeof publishResult.catch === 'function') {
          publishResult.catch(function () {});
        }
      }
    } catch (error) {
      // GTM remains the primary capture path when Customer Events is unavailable.
    }

    try {
      window.dispatchEvent(new CustomEvent('ufc:cta-ab-event', { detail: payload }));
    } catch (error) {
      // CustomEvent is only a convenience hook for local QA and other integrations.
    }
  }

  function observeExposure(element, context) {
    var exposed = false;

    function expose() {
      if (exposed) return;
      exposed = true;
      publish('cta_ab_exposure', context);
    }

    if (typeof window.IntersectionObserver !== 'function') {
      expose();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].isIntersecting && entries[i].intersectionRatio >= 0.5) {
          expose();
          observer.disconnect();
          break;
        }
      }
    }, { threshold: [0.5] });

    observer.observe(element);
  }

  function initializeElement(element) {
    if (element.getAttribute('data-ufc-cta-experiment-ready') === 'true') return;

    var experimentId = element.getAttribute('data-experiment-id');
    var labelA = element.getAttribute('data-variant-a-label');
    var labelB = element.getAttribute('data-variant-b-label');
    if (!experimentId || !labelA || !labelB) return;

    var assignment = assignmentFor(experimentId);
    var label = assignment.variant === 'B' ? labelB : labelA;
    var context = {
      experimentId: experimentId,
      variant: assignment.variant,
      label: label,
      assignmentSource: assignment.source,
      placement: element.getAttribute('data-experiment-placement') || 'unknown',
      destination: element.href,
      ga4MeasurementId: element.getAttribute('data-ga4-measurement-id') || ''
    };

    element.textContent = label;
    element.setAttribute('data-experiment-variant', assignment.variant);
    element.setAttribute('data-experiment-assignment-source', assignment.source);
    element.setAttribute('data-ufc-cta-experiment-ready', 'true');

    observeExposure(element, context);
    element.addEventListener('click', function () {
      publish('cta_ab_click', context);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < elements.length; i += 1) initializeElement(elements[i]);

    if (scope.matches && scope.matches(SELECTOR)) initializeElement(scope);
  }

  window.UfcCtaAbTest = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
